import {FORM_NAMES} from 'utils/guestForm';
import {AddFormType, AddFormV2Type} from 'context/guest';

export const sortFormNamesByOrder = (
  arr: FORM_NAMES[],
  formFields: AddFormType | AddFormV2Type,
) => arr.sort((a, b) => formFields[a]?.order - formFields[b]?.order);
